import React, { useState, useEffect, useCallback } from "react";
import CustomButton from "../../../atoms/CustomButton";
import { v4 as uuidv4 } from "uuid";
import { getData, patchData } from "../../../../services";
import { useCookies } from "react-cookie";
import moment from "moment/moment";
import Pagination from "../../../molecules/Pagination";
import Search from "../../../molecules/search";

import {
  getdepartmentList,
  getEmployeeList,
  getRolesList,
  getClientList,
  getAllProjects,
  getTeamsList,
  getBusinessSegmentList,
} from "../../../../services/basicGets";
import toast from "react-hot-toast";
import {
  errorStyles,
  confimationStyles,
  warningmoreStyles,
} from "../../../../assets/styles/toast";
import NoContentCard from "../../../atoms/NoContentCard";
import { Tooltip } from "@mui/material";
import TaskCustomDatagrid from "../../../organisms/CustomDatagrid/EditableTable";
import { CheckCheck, Loader, Upload } from "lucide-react";
import { handleClickDownload } from "../../../../services/downloadService";
import { useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { formatTime } from "../../../../helpers/timeformathoursminsec";
import Email from "../../../../assets/images/email";
import { capitalizeFirst } from "../../../../helpers/cookieHelper";

const ReportTasks = ({
  type,
  id,
  information,
  disabled = false,
  mytask,
  home,
  clientdash,
  clientshow,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [cookies] = useCookies([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [searchedValue, setSearchedValue] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [department, setDepartment] = useState([]);
  const [Projects, setProjects] = useState([]);
  const [roles, setRoles] = useState([]);
  const [Teams, setTeams] = useState([]);
  const [Client, setClient] = useState([]);
  const [BusinessSegment, setBusinessSegment] = useState([]);
  const [isDownload, setIsDownload] = useState();
  const [employees, setEmployees] = useState([]);
  const location = useLocation();
  const { name, start_date, end_date, project_report_id, approval_status } =
    location.state || {};

  // Initialize filters from URL params
  const [filters, setFilters] = useState(() => {
    const urlFilters = {};
    if (searchParams.has("status")) {
      urlFilters.status = JSON.parse(searchParams.get("status"));
    }
    if (searchParams.has("priority")) {
      urlFilters.priority = JSON.parse(searchParams.get("priority"));
    }
    if (searchParams.has("assignee")) {
      urlFilters.assignee = JSON.parse(searchParams.get("assignee"));
    }
    if (searchParams.has("delayed")) {
      urlFilters.delayed = JSON.parse(searchParams.get("delayed"));
    }
    return urlFilters;
  });

  const [isExporting, setIsExporting] = useState(false);

  //access details handling
  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const tasksAccess =
    accessData?.access?.find((module) => module.module === "Tasks") || {};
  const isAdmin = accessData?.role?.label === "Admin";

  const canCreate = isAdmin || tasksAccess?.is_create;
  const canEdit = isAdmin || tasksAccess?.is_edit;
  const canDelete = isAdmin || tasksAccess?.is_delete;
  const canExport = isAdmin || tasksAccess?.is_export;

  useEffect(() => {
    (async () => {
      const resEmployee = await getEmployeeList({
        params: { ...(!isAdmin && { employee_id: cookies.euid }) },
        token: cookies.e_t,
      });

      const resRoles = await getRolesList({
        token: cookies.e_t,
      });

      const resDepartments = await getdepartmentList({
        token: cookies.e_t,
      });

      const BusinessSegmentRoles = await getBusinessSegmentList({
        token: cookies.e_t,
      });

      const teams = await getTeamsList({
        ...(!isAdmin && { params: { employee_id: cookies.euid } }),
        token: cookies.e_t,
      });

      const projects = await getAllProjects({
        ...(!isAdmin && { params: { employee_id: cookies.euid } }),
        token: cookies.e_t,
      });

      const clients = await getClientList({
        token: cookies.e_t,
      });

      setBusinessSegment(BusinessSegmentRoles?.data);
      setClient(clients?.data);
      setRoles(resRoles);
      setProjects(projects?.data);
      setTeams(teams?.data?.teams);
      setDepartment(resDepartments);
      setEmployees(resEmployee?.employeeResponseValueLabel);
    })();
  }, []);

  const projectfilter = type === "Project" ? [id] : filters?.project || [];

  const getUserData = useCallback(async () => {
    try {
      setIsLoading(true);

      const delayedFilters = filters?.delayed || [];
      const recurringFilters = filters?.recurring || [];
      const dueToday = delayedFilters.includes("duetoday") ? true : null;
      const dueTomorrow = delayedFilters.includes("duetomorrow") ? true : null;
      const showOverdueTasks = delayedFilters.includes("duepast") ? true : null;
      const delayed = delayedFilters.includes("delayed") ? true : null;

      let recurringtaskFilter = null;
      if (recurringFilters.length === 1) {
        recurringtaskFilter = recurringFilters.includes("yes");
      }

      const res = await getData({
        endpoint: "Task/getClientTaskReport",
        params: {
          // employee_id: null,
          search_query: searchedValue,
          page: home ? 1 : currentPage,
          page_limit: home ? 20 : itemsPerPage,
          projects: JSON.stringify(projectfilter),
          employee_id:
            mytask || home ? cookies.euid : isAdmin ? null : cookies.euid,
          roles:
            home || mytask
              ? JSON.stringify(["isTeamMember", "isDirectlyAssigned"])
              : null,
          start_date: start_date,
          end_date: end_date,
        },

        token: cookies.e_t,
      });
      if (res) {
        setTableData(res?.data);
        const total_subtasks = res?.data?.subtasks_info?.total_subtasks;
        const completed_subtasks = res?.data?.subtasks_info?.completed_subtasks;
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [cookies.e_t, currentPage, itemsPerPage, searchedValue, filters]);

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  //handling menu

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleItemsPerPageChange = useCallback((perPage) => {
    setCurrentPage(1);
    setItemsPerPage(perPage);
  }, []);

  const getClientLists = async () => {
    const clients = await getClientList({
      token: cookies.e_t,
    });

    setClient(clients?.data);
  };

  const handleApprove = async (id, type) => {
    try {
      const dataToSend = {
        project_report_id: id,
        approved_by: cookies.euid,
        send_report_to_client: type === "sendmail" ? true : false,
      };
      const res = await patchData({
        endpoint: "/ProjectReportsGenerated/ApproveProject",
        data: {},
        params: dataToSend,
        token: cookies?.e_t,
      });
      if (res?.status) {
        toast.success("Project Report Approved Successfully", {
          duration: 2000,
          style: confimationStyles,
        });
      } else {
        toast.success(res?.message, {
          duration: 2000,
          style: warningmoreStyles,
        });
      }
    } catch (error) {
      console.error("Approve project report error:", error);
      throw error;
    } finally {
      setIsExporting(false);
    }
  };

  const handleDownload = async () => {
    try {
      setIsDownload(true);
      const res = await getData({
        endpoint: "Task/exportClientTaskReport",
        token: cookies.e_t,
        params: {
          roles:
            home || mytask
              ? JSON.stringify(["isTeamMember", "isDirectlyAssigned"])
              : null,
          projects: JSON.stringify([id]),
          start_date: start_date,
          end_date: end_date,
        },
      });

      if (res) {
        // Call the handleClickDownload function with the URL and desired file name
        await handleClickDownload(
          res,
          type === "Project"
            ? `Project ${information?.name} Task Report`
            : "TaskReport"
        );

        toast.success("Task Exported Successfully", {
          style: confimationStyles,
          duration: 2000,
        });
      } else {
        toast("An Error Occured Please Try Again Later.", {
          duration: 1000,
          style: errorStyles,
        });
      }
    } catch (error) {
      toast.error("An Error Occured.", { style: errorStyles, duration: 1000 });
    } finally {
      setIsDownload(false);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Task Title",
      minWidth: 280,
      sortable: true,
      cellClassName: "cursor-pointer",
      renderCell: (params) => {
        const totalSubtasks = params?.row?.subtasks_info?.total_subtasks || 0;
        const completedSubtasks =
          params?.row?.subtasks_info?.completed_subtasks || 0;
        const displayText = capitalizeFirst(params.value);

        return (
          <div className="d-flex align-items-center justify-content-between w-100">
            <div>
              <Tooltip
                title={`${displayText} - ${completedSubtasks}/${totalSubtasks}`}
                arrow
              >
                <span className="multiline-ellipsis">{displayText}</span>
              </Tooltip>
            </div>
            <div>
              {totalSubtasks > 0 && (
                <div className="flex items-center ml-2 text-gray-500">
                  <CheckCheck size={16} className="mr-1" />
                  <span style={{ fontSize: "0.85rem" }}>
                    {completedSubtasks}/{totalSubtasks}
                  </span>
                </div>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "total_elapsed",
      headerName: "Logged Time",
      minWidth: 150,
      sortable: true,
      renderCell: (params) => {
        return <span>{formatTime(params?.row?.total_elapsed)}</span>;
      },
    },

    {
      field: "client",
      headerName: "Client",
      minWidth: 150,
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span className="multiline-ellipsis">{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "assigned_emp",
      headerName: "Assigned To",
      cellClassName: "cursor-pointer",
      minWidth: 200,
      sortable: true,
      editable: false,

      renderCell: (params) => {
        const employees = params.row.assigned_emp || [];

        // Show first two and the count of remaining
        const displayText = employees;

        return (
          <Tooltip title={employees} arrow>
            <span
              style={{
                cursor: "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {displayText}
            </span>
          </Tooltip>
        );
      },
    },

    {
      field: "created_by_name",
      headerName: "Created By",
      minWidth: 150,
      renderCell: (params) => {
        return <span style={{}}>{params?.row?.created_by_name}</span>;
      },
      sortable: true,
    },
    {
      field: "created_date",
      headerName: "Created Date",
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div>
            {params?.row?.created_date &&
              moment(params.row?.created_date).format("DD/MM/YYYY hh:mm a")}
          </div>
        );
      },
      sortable: true,
    },
  ];

  const getFilteredColumns = () => {
    if (home) {
      // Return only specific columns for home view (up to assigned_teams)
      return columns.filter((col) =>
        [
          "name",
          "elapsed_time",
          "client_name",
          "project_name",
          "assigned_employees",
          "assigned_teams",
          "actions",
        ].includes(col.field)
      );
    }
    return columns;
  };

  const handleFilterChange = (newFilters) => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
    setFilters(newFilters);
  };

  const CustomNoRowsOverlay = React.memo(() => {
    return (
      <>
        <NoContentCard
          title="No Tasks Found"
          type="Task"
          // subtitle={
          //   "Looks like you’re all caught up—check back later for new assignments."
          // }
        />
      </>
    );
  });

  return (
    <div
      id="Employee-Management"
      className={
        !home && !clientshow ? "main-container" : "main-container-home"
      }
    >
      {!home && !clientshow ? (
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-2 segregation-container">
            <Search
              placeholder="Search"
              onSearchEmit={(item) => {
                if (currentPage !== 1) {
                  setCurrentPage(1);
                }
                setSearchedValue(item);
              }}
              style={{ maxWidth: "240px" }}
            />
            <div className="btn btn-outline-dark px-4 mt-0">
              {start_date &&
                end_date &&
                `${moment(start_date).format("DD/MM/YYYY")} - ${moment(
                  end_date
                ).format("DD/MM/YYYY")}`}
            </div>
          </div>

          <div
            className="d-flex gap-2"
            style={{ width: approval_status ? "35%" : "60%" }}
          >
            {!approval_status && (
              <CustomButton
                text="Approve"
                type="btn-primary"
                handleClick={() => handleApprove(project_report_id)}
                iconRequired={false}
              />
            )}
            {/* {canExport && ( */}
            <>
              <CustomButton
                text={
                  isExporting
                    ? "Approving & Sending Mail..."
                    : "Approve & Send Mail"
                }
                handleClick={() => handleApprove(project_report_id, "sendmail")}
                icon={
                  isExporting ? (
                    <Loader className="animate-spin" size={18} />
                  ) : (
                    <Email />
                  )
                }
                disabled={isExporting || disabled}
                iconRequired
                forMobile
              />
              <CustomButton
                text={isDownload ? "Exporting Report..." : "Export Report"}
                handleClick={() => handleDownload()}
                icon={
                  isDownload ? (
                    <Loader className="animate-spin" size={18} />
                  ) : (
                    <Upload size={16} />
                  )
                }
                disabled={isDownload || disabled}
                iconRequired
              />
            </>
            {/* )} */}
          </div>
        </div>
      ) : null}

      <div className="mt-3">
        <TaskCustomDatagrid
          columns={getFilteredColumns()}
          CustomNoRowsOverlay={CustomNoRowsOverlay}
          rows={tableData?.report_data || []}
          getRowId={(row) => row.t_task_id}
          isLoadingStateProvided={true}
          isLoading={isLoading}
          onCellClick={(params, event) => {
            if (params.field === "name" && canEdit) {
              setAnchorEl(null);
            }
          }}
        />
      </div>

      {!home && tableData?.total_records > 10 && (
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={tableData?.total_records}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      )}
    </div>
  );
};

export default ReportTasks;
